export default __webpack_public_path__ + "static/media/amrakImg.225367ef.png";